module.exports = __webpack_public_path__ + "img/discount_icon.7c0fff15.svg";